// FEATURED COLLECTION (namespace .s-featured)
// - Quick add com fetch
// - Abertura instantânea do cart drawer (Halo)
// - Proteção contra duplicação (LOCK GLOBAL)

(function () {

  // 🔒 LOCK GLOBAL — impede add duplicado por race condition
  if (window.__FEATURED_QUICK_ADD_LOADED__) return;
  window.__FEATURED_QUICK_ADD_LOADED__ = true;

  window.__FEATURED_ADD_IN_PROGRESS__ = false;

  function initPromoCountdown(section) {
    if (!section) return;

    section.querySelectorAll('[data-featured-countdown]').forEach(function (countdown) {
      if (countdown.__featuredCountdownTimer) {
        clearInterval(countdown.__featuredCountdownTimer);
      }

      var dateValue = String(countdown.getAttribute('data-countdown-date') || '').trim();
      var timeValue = String(countdown.getAttribute('data-countdown-time') || '23:59').trim();
      var strip = countdown.closest('[data-featured-promo-strip]');
      var expiredMessage = strip && strip.querySelector('[data-countdown-expired]');
      var expireBehavior =
        countdown.getAttribute('data-countdown-expire-behavior') || 'message';

      function normalizeDate(value) {
        var normalizedValue = value.replace(/\./g, '/');

        var isoMatch = normalizedValue.match(/^(\d{4})[-\/](\d{2})[-\/](\d{2})$/);
        if (isoMatch) {
          return isoMatch[1] + '-' + isoMatch[2] + '-' + isoMatch[3];
        }

        var brMatch = normalizedValue.match(/^(\d{2})[-\/](\d{2})[-\/](\d{4})$/);
        if (brMatch) {
          return brMatch[3] + '-' + brMatch[2] + '-' + brMatch[1];
        }

        return '';
      }

      function normalizeTime(value) {
        var match = value.match(/^(\d{1,2}):(\d{2})$/);
        if (!match) return '';

        var hours = Number(match[1]);
        var minutes = Number(match[2]);

        if (
          !Number.isInteger(hours) ||
          !Number.isInteger(minutes) ||
          hours < 0 ||
          hours > 23 ||
          minutes < 0 ||
          minutes > 59
        ) {
          return '';
        }

        return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0');
      }

      var normalizedDate = normalizeDate(dateValue);
      var normalizedTime = normalizeTime(timeValue);

      if (!normalizedDate || !normalizedTime) {
        countdown.setAttribute('data-countdown-invalid', 'true');
        return;
      }

      var endTimestamp = Date.parse(
        normalizedDate + 'T' + normalizedTime + ':00-03:00'
      );

      if (!Number.isFinite(endTimestamp)) {
        countdown.setAttribute('data-countdown-invalid', 'true');
        return;
      }

      countdown.removeAttribute('data-countdown-invalid');

      var daysEl = countdown.querySelector('[data-countdown-days]');
      var hoursEl = countdown.querySelector('[data-countdown-hours]');
      var minutesEl = countdown.querySelector('[data-countdown-minutes]');
      var secondsEl = countdown.querySelector('[data-countdown-seconds]');

      function pad(value) {
        return String(Math.max(0, value)).padStart(2, '0');
      }

      function finishCountdown() {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minutesEl) minutesEl.textContent = '00';
        if (secondsEl) secondsEl.textContent = '00';

        if (countdown.__featuredCountdownTimer) {
          clearInterval(countdown.__featuredCountdownTimer);
          countdown.__featuredCountdownTimer = null;
        }

        if (expireBehavior === 'hide_card' && strip) {
          strip.hidden = true;
          return;
        }

        countdown.hidden = true;

        if (expireBehavior === 'message' && expiredMessage) {
          expiredMessage.hidden = false;
        }
      }

      function updateCountdown() {
        var remaining = endTimestamp - Date.now();

        if (remaining <= 0) {
          finishCountdown();
          return;
        }

        var totalSeconds = Math.floor(remaining / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = daysEl
          ? Math.floor((totalSeconds % 86400) / 3600)
          : Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      if (strip) strip.hidden = false;
      if (expiredMessage) expiredMessage.hidden = true;
      countdown.hidden = false;

      updateCountdown();

      if (!countdown.hidden) {
        countdown.__featuredCountdownTimer = setInterval(updateCountdown, 1000);
      }
    });
  }

  function openCartDrawer() {
    var openBtn =
      document.querySelector('[data-open-cart-sidebar]') ||
      document.querySelector('[data-cart-toggle]');

    if (openBtn) {
      openBtn.click();
      return;
    }

    // Fallback mínimo
    document.body.classList.add('open-cart-sidebar');
  }

  function initQuickAdd(section) {
  var forms = section.querySelectorAll('.s-featured__quick-add-form');
  if (!forms.length) return;

  forms.forEach(function (form) {
    var submitButton = form.querySelector('[data-quick-add-button]');
    if (!submitButton) return;

    var label = submitButton.querySelector('.s-featured__cta-label');
    var defaultLabel = label ? label.textContent : 'Comprar';

    function setLoading() {

      submitButton.classList.add('is-loading');

      var isMobileGrid =
        window.innerWidth < 768 &&
        section &&
        !section.classList.contains('s-featured--carousel');

      if (!isMobileGrid && label) {
        label.textContent = 'Adicionando...';
      }
    }

    function resetLoading() {
      submitButton.classList.remove('is-loading');

      if (label) {
        label.textContent = form.getAttribute('data-current-label') || defaultLabel;
      }
    }

    form.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    submitButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (submitButton.classList.contains('is-loading')) return;
      if (window.__FEATURED_ADD_IN_PROGRESS__) return;

      window.__FEATURED_ADD_IN_PROGRESS__ = true;

      if (!window.fetch) {
        window.__FEATURED_ADD_IN_PROGRESS__ = false;
        return;
      }

      var formData = new FormData(form);
      var variantId = formData.get('id');

      if (!variantId) {
        console.error('[FEATURED] Variant ID inválido');
        window.__FEATURED_ADD_IN_PROGRESS__ = false;
        return;
      }

      // 🔥 loading instantâneo + drawer
      setLoading();
      openCartDrawer();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error(
                (data && (data.description || data.message)) ||
                'Erro ao adicionar produto ao carrinho.'
              );
            });
          }

          return res.json();
        })
        .then(function () {
          if (typeof Shopify !== 'undefined' && Shopify.getCart) {
            Shopify.getCart(function (cart) {
              if (typeof window.updateCart === 'function') {
                window.updateCart(cart);
              }
            });
          }
        })
        .catch(function (err) {
          if (
            window.SubscriptionCartPolicy &&
            window.SubscriptionCartPolicy.isMixedCartError(err)
          ) {
            window.SubscriptionCartPolicy.showMixedCartAlert({
              onClear: function () {
                submitButton.click();
              }
            });

            return;
          }

          console.error('[FEATURED] Erro no quick add:', err);
        })
        .finally(function () {
          resetLoading();
          window.__FEATURED_ADD_IN_PROGRESS__ = false;
        });
    });
  });
}

  function initVariantSelectors(section) {
    section.querySelectorAll('[data-featured-variants]').forEach(function (variantsUi) {
      var card = variantsUi.closest('[data-featured-card]');
      var toggle = variantsUi.querySelector('[data-variants-toggle]');
      var panel = variantsUi.querySelector('[data-variants-panel]');
      var dropdownLabel = variantsUi.querySelector('.s-featured__dropdown-label');

      if (!card || !toggle || !panel) return;

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var willOpen = panel.hidden;
        panel.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', String(willOpen));
      });

      variantsUi.querySelectorAll('[data-variant-id]').forEach(function (option) {
        option.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (option.disabled) return;

          var form = card.querySelector('.s-featured__quick-add-form');
          var variantInput = form && form.querySelector('input[name="id"]');
          var submitButton = form && form.querySelector('[data-quick-add-button]');
          var ctaLabel = submitButton && submitButton.querySelector('.s-featured__cta-label');
          var currentPrice = card.querySelector('.digi-price__current');
          var comparePrice = card.querySelector('.digi-price__compare');
          var installment = card.querySelector('.s-featured__installments');
          var isPreorder = option.getAttribute('data-variant-preorder') === 'true';

          if (variantInput) {
            variantInput.value = option.getAttribute('data-variant-id');
          }

          if (dropdownLabel) {
            dropdownLabel.textContent = option.getAttribute('data-variant-label') || '';
          }

          if (currentPrice) {
            currentPrice.textContent = option.getAttribute('data-variant-price') || '';
          }

          if (comparePrice) {
            comparePrice.textContent = option.getAttribute('data-variant-compare-price') || '';
          }

          if (installment) {
            var installmentPrice = option.getAttribute('data-variant-installment-price');
            installment.textContent = installment.textContent.replace(/de\s+.+$/, 'de ' + installmentPrice);
          }

          if (submitButton && ctaLabel) {
            var selectedLabel = isPreorder
              ? (submitButton.getAttribute('data-preorder-label') || 'RESERVAR')
              : (submitButton.getAttribute('data-purchase-label') || 'COMPRAR');

            ctaLabel.textContent = selectedLabel;

            if (form) {
              form.setAttribute('data-current-label', selectedLabel);
            }
          }

          variantsUi.querySelectorAll('[data-variant-id]').forEach(function (item) {
            var isSelected = item === option;
            item.classList.toggle('is-active', isSelected);
            item.setAttribute('aria-selected', String(isSelected));
          });

          panel.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
        });
      });
    });
  }

  function initReveal(section) {
    if (!section.classList.contains('s-featured--reveal')) return;

    if (!('IntersectionObserver' in window)) {
      section.querySelectorAll('.s-featured__card').forEach(function (card) {
        card.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    section.querySelectorAll('.s-featured__card').forEach(function (card) {
      observer.observe(card);
    });
  }

  function initCouponCopy(section) {
    const buttons = section.querySelectorAll('.s-featured__coupon-badge');
    if (!buttons.length) return;

    buttons.forEach((btn) => {
      const codeEl = btn.querySelector('.s-featured__coupon-code');
      const originalCode = codeEl ? codeEl.textContent : '';

      btn.addEventListener('click', () => {
        const coupon = btn.getAttribute('data-coupon');
        if (!coupon) return;

        navigator.clipboard.writeText(coupon).then(() => {
          btn.classList.add('is-copied');

          const labelEl = btn.querySelector('.s-featured__coupon-label');

          if (labelEl) {
            labelEl.textContent = 'CUPOM';
          }

          if (codeEl) {
            codeEl.textContent = 'COPIADO';
          }

          setTimeout(() => {
            btn.classList.remove('is-copied');

            if (labelEl) {
              labelEl.textContent = 'CUPOM';
            }

            if (codeEl) {
              codeEl.textContent = originalCode;
            }
          }, 2000);
        });
      });
    });
  }  

// ==============================
// CARROSSEL DESKTOP – NAVEGAÇÃO
// ==============================
function updateFeaturedNav(section) {
  if (window.innerWidth < 1024) return;

  var list = section.querySelector('.s-featured__list');
  var cards = section.querySelectorAll('.s-featured__card:not([hidden])');

  var prevBtn = section.querySelector('.s-featured__nav-btn.is-prev');
  var nextBtn = section.querySelector('.s-featured__nav-btn.is-next');

  if (!list || !prevBtn || !nextBtn) return;

  var cardsPerView = 4;

  if (cards.length <= cardsPerView) {
    prevBtn.style.visibility = 'hidden';
    nextBtn.style.visibility = 'hidden';
    return;
  }

  var maxScrollLeft = list.scrollWidth - list.clientWidth;
  var currentScroll = Math.round(list.scrollLeft);

  var isAtStart = currentScroll < 30;
  var isAtEnd = currentScroll >= maxScrollLeft - 30;

  if (isAtStart) {
    prevBtn.style.visibility = 'hidden';
    nextBtn.style.visibility = 'visible';
    return;
  }

  if (isAtEnd) {
    prevBtn.style.visibility = 'visible';
    nextBtn.style.visibility = 'hidden';
    return;
  }

  prevBtn.style.visibility = 'visible';
  nextBtn.style.visibility = 'visible';
}

// =====================================
// LAZY LOAD DA SEGUNDA IMAGEM
// =====================================

function initSecondaryImages(section) {

  if (window.innerWidth < 768) return;

  if (!('IntersectionObserver' in window)) return;

  var cards = section.querySelectorAll('.s-featured__card');

  if (!cards.length) return;

  var observer = new IntersectionObserver(function(entries) {

    entries.forEach(function(entry) {

      if (!entry.isIntersecting) return;

      var card = entry.target;

      var media = card.querySelector('.s-featured__media');

      var template = card.querySelector('.s-featured__secondary-template');

      if (!media || !template) {
        observer.unobserve(card);
        return;
      }

      // evita duplicação
      if (!media.querySelector('.s-featured__image--secondary')) {

        media.insertAdjacentHTML(
          'beforeend',
          template.innerHTML
        );

      }

      observer.unobserve(card);

    });

  }, {
    rootMargin: '200px'
  });

  cards.forEach(function(card) {
    observer.observe(card);
  });

}

function initCarouselNav(section) {

  var prevBtn = section.querySelector('.s-featured__nav-btn.is-prev');
  var nextBtn = section.querySelector('.s-featured__nav-btn.is-next');
  var list = section.querySelector('.s-featured__list');

  if (!prevBtn || !nextBtn || !list) return;

  function handleClick(btn) {

    var card = list.querySelector('.s-featured__card:not([hidden])');

    if (!card) return;

    var styles = window.getComputedStyle(list);

    var gap = parseInt(styles.columnGap || styles.gap || 0, 10);

    var cardsPerView = 4;

    var scrollAmount =
      (card.offsetWidth + gap) * cardsPerView;

    list.scrollBy({
      left: btn.classList.contains('is-next')
        ? scrollAmount
        : -scrollAmount,
      behavior: 'smooth',
    });

    setTimeout(function () {
      updateFeaturedNav(section);
    }, 400);
  }

  prevBtn.addEventListener('click', function() {
    handleClick(prevBtn);
  });

  nextBtn.addEventListener('click', function() {
    handleClick(nextBtn);
  });

}

/* =====================================================
   FEATURED INTERNAL FILTERS
===================================================== */

function normalizeFeaturedValue(value) {
  return String(value || '')
    .trim()
    .toLowerCase();
}

function getActiveFeaturedFilters(section) {
  var filters = {
    line: [],
    protein: [],
    weight: [],
    minPrice: null,
    maxPrice: null
  };

  var checkedInputs = section.querySelectorAll(
    '[data-featured-filters-form] .digi-search-filters__checkbox:checked'
  );

  checkedInputs.forEach(function (input) {
    var key = input.getAttribute('data-filter-key');
    var value = normalizeFeaturedValue(input.value);

    if (!key || !value) return;

    if (!filters[key]) {
      filters[key] = [];
    }

    filters[key].push(value);
  });

  var minPriceInput = section.querySelector(
    '[data-featured-filters-form] [data-price-min]'
  );
  var maxPriceInput = section.querySelector(
    '[data-featured-filters-form] [data-price-max]'
  );

  if (minPriceInput) {
    filters.minPrice = Number(minPriceInput.value);
  }

  if (maxPriceInput) {
    filters.maxPrice = Number(maxPriceInput.value);
  }

  return filters;
}

function matchesFeaturedFilters(card, filters) {
  var line = normalizeFeaturedValue(card.getAttribute('data-line'));
  var protein = normalizeFeaturedValue(card.getAttribute('data-protein'));
  var weight = normalizeFeaturedValue(card.getAttribute('data-weight'));
  var price = Number(card.getAttribute('data-price'));

  if (Number.isFinite(filters.minPrice) && price < filters.minPrice) {
    return false;
  }

  if (Number.isFinite(filters.maxPrice) && price > filters.maxPrice) {
    return false;
  }

  if (filters.line.length && !filters.line.includes(line)) {
    return false;
  }

  if (filters.protein.length && !filters.protein.includes(protein)) {
    return false;
  }

  if (filters.weight.length && !filters.weight.includes(weight)) {
    return false;
  }

  return true;
}

function updateFeaturedFilterCount(section, visibleCount) {
  var countEl = section.querySelector('[data-featured-count]');

  if (!countEl) return;

  countEl.textContent =
    visibleCount === 1
      ? '1 produto'
      : visibleCount + ' produtos';
}

function getFeaturedProductsPerPage(section) {
  var value = parseInt(section.getAttribute('data-featured-products-per-page'), 10);

  return Number.isFinite(value) && value > 0 ? value : 8;
}

function renderFeaturedPagination(section, currentPage, totalPages) {
  var pagination = section.querySelector('[data-featured-pagination-nav]');
  var pageList = section.querySelector('[data-featured-page-list]');
  var prevButton = section.querySelector('[data-featured-page-prev]');
  var nextButton = section.querySelector('[data-featured-page-next]');

  if (!pagination || !pageList || !prevButton || !nextButton) return;

  pagination.hidden = totalPages <= 1;
  pageList.innerHTML = '';

  if (totalPages <= 1) return;

  for (var page = 1; page <= totalPages; page += 1) {
    var button = document.createElement('button');

    button.type = 'button';
    button.className = 's-featured__pagination-button';
    button.textContent = page;
    button.setAttribute('data-featured-page', page);
    button.setAttribute('aria-label', 'Ir para a página ' + page);

    if (page === currentPage) {
      button.classList.add('is-active');
      button.setAttribute('aria-current', 'page');
      button.disabled = true;
    }

    pageList.appendChild(button);
  }

  prevButton.disabled = currentPage === 1;
  nextButton.disabled = currentPage === totalPages;
}

function applyFeaturedFilters(section, requestedPage) {
  var cards = Array.prototype.slice.call(
    section.querySelectorAll('[data-featured-card]')
  );
  var filters = getActiveFeaturedFilters(section);
  var matchingCards = cards.filter(function (card) {
    return matchesFeaturedFilters(card, filters);
  });
  var paginationEnabled =
    section.getAttribute('data-featured-pagination') === 'true';
  var productsPerPage = getFeaturedProductsPerPage(section);
  var totalPages = paginationEnabled
    ? Math.max(1, Math.ceil(matchingCards.length / productsPerPage))
    : 1;
  var currentPage = Math.min(
    Math.max(parseInt(requestedPage, 10) || 1, 1),
    totalPages
  );
  var pageStart = (currentPage - 1) * productsPerPage;
  var pageEnd = pageStart + productsPerPage;

  cards.forEach(function (card) {
    var matchingIndex = matchingCards.indexOf(card);
    var isOnCurrentPage =
      matchingIndex !== -1 &&
      (!paginationEnabled ||
        (matchingIndex >= pageStart && matchingIndex < pageEnd));

    card.hidden = !isOnCurrentPage;
  });

  section.setAttribute('data-featured-current-page', currentPage);
  updateFeaturedFilterCount(section, matchingCards.length);
  renderFeaturedPagination(
    section,
    currentPage,
    paginationEnabled ? totalPages : 1
  );

  var list = section.querySelector('.s-featured__list');

  if (list) {
    list.scrollLeft = 0;
  }

  updateFeaturedNav(section);
}

function initFeaturedFilters(section) {
  var form = section.querySelector('[data-featured-filters-form]');
  var pagination = section.querySelector('[data-featured-pagination-nav]');

  if (!form) return;

  form.addEventListener('change', function (event) {
    var target = event.target;

    if (!target.matches('.digi-search-filters__checkbox, .digi-search-filters__range-input')) return;

    applyFeaturedFilters(section, 1);
  });

  if (pagination) {
    pagination.addEventListener('click', function (event) {
      var button = event.target.closest('button');

      if (!button || button.disabled) return;

      var currentPage =
        parseInt(section.getAttribute('data-featured-current-page'), 10) || 1;
      var requestedPage = currentPage;

      if (button.hasAttribute('data-featured-page-prev')) {
        requestedPage = currentPage - 1;
      } else if (button.hasAttribute('data-featured-page-next')) {
        requestedPage = currentPage + 1;
      } else if (button.hasAttribute('data-featured-page')) {
        requestedPage =
          parseInt(button.getAttribute('data-featured-page'), 10) || 1;
      } else {
        return;
      }

      applyFeaturedFilters(section, requestedPage);

      var viewport = section.querySelector('.s-featured__viewport');

      if (viewport) {
        viewport.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  applyFeaturedFilters(section, 1);
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.s-featured').forEach(function (section) {
    initQuickAdd(section);
    initVariantSelectors(section);
    initReveal(section);
    initCouponCopy(section);
    initPromoCountdown(section);
    initSecondaryImages(section);
    initCarouselNav(section);
    initFeaturedFilters(section);

    var list = section.querySelector('.s-featured__list');

    if (list) {
      list.scrollLeft = 0;
    }

    updateFeaturedNav(section);

    var list = section.querySelector('.s-featured__list');

    if (list) {
      list.addEventListener('scroll', function () {
        updateFeaturedNav(section);
      });

      window.addEventListener('resize', function () {
        updateFeaturedNav(section);
      });
    }
  });
});

document.addEventListener('shopify:section:load', function (event) {
  var root = event.target;
  var section = null;

  if (root && root.matches && root.matches('.s-featured')) {
    section = root;
  } else if (root && root.querySelector) {
    section = root.querySelector('.s-featured');
  }

  if (section) {
    initPromoCountdown(section);
  }
});

})();


